import { render, staticRenderFns } from "./Discipline.vue?vue&type=template&id=14c2e9f8&scoped=true"
import script from "./Discipline.vue?vue&type=script&lang=js"
export * from "./Discipline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c2e9f8",
  null
  
)

export default component.exports